/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowRoundTimeBackIcon24Solid = forwardRef('ArrowRoundTimeBackIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M8.175 5.26a7.75 7.75 0 1 1-3.258 9.886 1.25 1.25 0 0 0-2.285 1.015A10.25 10.25 0 1 0 4.25 5.29V3.038a1.25 1.25 0 1 0-2.5 0v5.754A1.25 1.25 0 0 0 3 10.04h5.5a1.25 1.25 0 0 0 0-2.5H5.661A7.75 7.75 0 0 1 8.175 5.26Z" })));
});
